exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container--G-3V4{display:flex;background-color:#fff;align-items:center;padding:15px;box-shadow:0 4px 4px 0 rgba(0,0,0,.2);margin-bottom:20px;gap:10px}.container--G-3V4.notVisible--1wvN-{opacity:0}.imageContainer--3HqHS{max-width:33%}.description--3MusI{display:flex;flex-direction:column;gap:10px}.description--3MusI strong:first-child{font-size:16px}.description--3MusI em:nth-child(2){font-size:10px}.description--3MusI strong:nth-child(3){font-size:14px}", ""]);

// Exports
exports.locals = {
	"container": "container--G-3V4",
	"notVisible": "notVisible--1wvN-",
	"imageContainer": "imageContainer--3HqHS",
	"description": "description--3MusI"
};